$(document).ready(function () {

    $('#table-orders').dataTable({
        "processing": true,
        "serverSide": true,
        "ajax": "orders-by-ajax",
        "columns": [
            {data: 'order_id'},
            {data: 'date'},
            {data: 'time'},
            {data: 'customers.fullName'},
            {data: 'customers.email'},
            {data: 'payment_method'},
            {data: 'status'},
        ],
        "order": [[0, "desc"], [1, "desc"], [2, "desc"]],
        "columnDefs": [
            {
                "targets": 5,
                "render": function (data, type, row, meta) {

                    if (row.payment_method === "card") return "Tarjeta";
                    if (row.payment_method === "store") return "Paynet";
                    if (row.payment_method === "spei") return "SPEI";

                    return row.payment_method;
                }
            },
            {
                "targets": 7,
                "render": function (data, type, row, meta) {
                    return '<a href="' + '/admin/view-detail/' + row.order_id + '" class="btn btn-primary" target="_blank" ' +
                        'data-toggle="tooltip" title="Ver detalle"><i class="fas fa-th-list"></i></a> '
                }
            }],
        "createdRow": function (row, data, index) {

            var createdAt = new Date(data.created_at);
            var now = new Date();

            var hoursDifference = (now - createdAt) / (1000 * 60 * 60);

            if (["Confirmado", "Confirmación de pago", "Pago confirmado", "Envíado"].includes(data.status) && hoursDifference > 48) {
                $(row).addClass('table-danger');
                $(row).attr('data-toggle', 'tooltip');
                $(row).attr('title', 'Advertencia: Esta fila ha excedido el plazo de 48 horas desde su creación y está fuera del tiempo');
                $(row).tooltip();
            }
        },
        "language": {
            url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
        },
    });


    window.myFuncion = function () {

        let status = $('select[id=status]').val();
        let msj = $('#msj').val();
        let order = $('#order').val();

        let sendMail = 'N';

        if ($('#chk').prop('checked')) sendMail = 'S';

        let envio = 0;

        if ($('#div_envio').is(':visible')) {
            envio = $('#sent_envio').val();
        }

        swal.fire({
            title: '¿Estas seguro?',
            text: "¿Desea cambiar el estatus del pedido?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#023B59',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, cambiar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                $.ajax({
                    url: window.location.origin + '/admin/change/status/order',
                    type: 'POST',
                    data: {
                        status: status,
                        msj: msj,
                        order: order,
                        sendMail: sendMail,
                        envio: envio
                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {

                        if (data['status'] === 'ok') {
                            swal.fire({
                                title: 'Actualizado',
                                text: data['msj'],
                                icon: 'success',
                                confirmButtonColor: '#003b5a',
                            }).then((result) => {
                                location.reload();
                            });
                        } else {
                            swal.fire({
                                title: 'Advertencia',
                                text: data['msj'],
                                icon: 'error',
                                confirmButtonColor: '#003b5a',
                            }).then((result) => {
                                location.reload();
                            });
                        }
                    },
                    error: function (errors, xhr, status,) {
                        alert('Ocurrió un problema')
                    }
                })

            }
        })
    }

    window.showMsj = function (status, order) {
        event.preventDefault();

        /*if (status === '3') {
            $("#div_envio").show();
        } else {
            $("#div_envio").hide();
        }*/

        $.ajax({
            url: window.location.origin + '/admin/show/msj/status/' + status + '/' + order,
            type: 'GET',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {
                $("#msj").val(response);
            })
            .fail(function (jqXHR, textStatus) {
                Swal.fire({
                    title: 'Advertencia',
                    text: 'Ocurrió un problema',
                    icon: 'error',
                    confirmButtonColor: '#003b5a',
                });
            });
    }


    $("#edit").click(function () {
        if ($("#edit").is(':checked')) {
            $("#msj").attr("readonly", false);
        } else {
            $("#msj").attr("readonly", true);
        }
    });


})
